export enum CurrencySelectionActionTypes {
  OPEN_CURRENCY_SELECTION_ASSEMBLY_MODAL = "OPEN_CURRENCY_SELECTION_ASSEMBLY_MODAL",
  SET_CURRENCY_SELECTION_MODAL_DATA = "SET_CURRENCY_SELECTION_MODAL_DATA",
  CLOSE_CURRENCY_SELECTION_MODAL = "CLOSE_CURRENCY_SELECTION_MODAL",
  CLEAR_CURRENCY_SELECTION_DATA = "CLEAR_CURRENCY_SELECTION_DATA",
  UPDATE_CURRENCY_SELECTION = "UPDATE_CURRENCY_SELECTION"
}
